<template>
  <Organisation
    :title="
      `Edit: ${user.first_name} ${user.last_name} | Users | Organisation Settings`
    "
  >
    <div class="container">
      <div class="row">
        <div class="col-sm-8 offset-sm-2">
          <h1 class="mb-4">Edit: {{ user.first_name }} {{ user.last_name }}</h1>
          <form @submit.prevent="submit">
            <div class="row">
              <div class="form-group col-sm-6">
                <TextInput
                  label="First Name"
                  v-model="form.first_name"
                  :errors="$page.props.errors.first_name"
                  type="text"
                  autofocus
                  autocapitalize="off"
                  placeholder="Jane"
                />
              </div>
              <div class="form-group col-sm-6">
                <TextInput
                  label="Last Name"
                  v-model="form.last_name"
                  :errors="$page.props.errors.last_name"
                  type="text"
                  autocapitalize="off"
                  placeholder="Doe"
                />
              </div>
            </div>

            <div class="form-group">
              <TextInput
                label="Email"
                v-model="form.email"
                :errors="$page.props.errors.email"
                type="email"
                autocapitalize="off"
                placeholder="jane.doe@example.com"
              />
            </div>

            <div class="form-group">
              <h3>Roles</h3>
              <CheckboxInput
                v-for="role in roles"
                :key="role.id"
                :label="role.label"
                v-model="form.roles"
                :errors="$page.props.errors.roles"
                :val="role.id"
              />
            </div>

            <div class="form-group">
              <div class="row">
                <div class="col-md-3">
                  <inertia-link
                    :href="
                      route('organisation.user.index', this.organisation.id)
                    "
                    class="btn btn-secondary btn-block"
                    >Cancel</inertia-link
                  >
                </div>
                <div class="col-md-3">
                  <LoadingButton
                    :loading="sending"
                    class="btn btn-primary btn-block"
                    type="submit"
                    >Save</LoadingButton
                  >
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </Organisation>
</template>

<script>
import Organisation from '@/Pages/Account/Organisation/Organisation';
import LoadingButton from '@/Shared/LoadingButton';
import TextInput from '@/Shared/Inputs/Text';
import CheckboxInput from '@/Shared/Inputs/Checkbox';

export default {
  components: {
    Organisation,
    LoadingButton,
    TextInput,
    CheckboxInput,
  },

  props: {
    organisation: Object,
    user: Object,
    roles: Array,
  },

  data() {
    return {
      sending: false,
      form: this.$inertia.form({
        first_name: this.user.first_name,
        last_name: this.user.last_name,
        email: this.user.email,
        roles: this.user.roles ? this.user.roles.flatMap((r) => r.id) : [],
      }),
    };
  },

  methods: {
    submit() {
      this.sending = true;

      this.form.put(this.route('organisation.user.update', [this.organisation.id, this.user.id]), {
        preserveScroll: true,
        onSuccess: () => {
          this.sending = false;
        },
      });
    },
  },
};
</script>
